import { useMobile } from "../../../../../../context/MobileContext";
import styles from "./style.module.scss";
import "./style.scss";

const GridCards = ({ cardsEnum }) => {
  const { isWidthMiddle } = useMobile();
  const renderCard = (item, index) => {
    return (
      <div
        className={`card card-${index + 1}`}
        style={{
          backgroundImage: `url(${
            isWidthMiddle ? (item.gridSrc ? item.gridSrc : item.src) : item.src
          })`,
        }}
      >
        <div className="text-container">
          <div className="title">{item.title}</div>
          <div className="content">{item.content}</div>
        </div>
      </div>
    );
  };

  return (
    <div className={`${styles.cardsContainer} grid-cards`}>
      {cardsEnum.map((item, index) => renderCard(item, index))}
    </div>
  );
};

export default GridCards;
